import { useEffect, useState } from "react";
import { Load } from "../load/load";
import { NotFoundPage } from "../../pages/not-found/notfound";
import { AuthRepository } from "./auth.repository";
interface AuthGuardProps {
    protectedPage: React.ReactNode;
}

export const AuthGuard = ({ protectedPage }: AuthGuardProps) => {
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);
    useEffect(() => {
        let cancelled = false;


        const validateAuth = async () => {
            const { authorized } = await AuthRepository.me();
            if (!cancelled) {
                setIsAuthorized(authorized);
            }
        }

        validateAuth();
        return () => {
            cancelled = true;
        };
    }, []);

    if (isAuthorized === null) {
        return <Load variant="solid-black" />;
    }

    if (!isAuthorized) {
        return <NotFoundPage />;
    }

    return <>{protectedPage}</>;
};
